import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';
import { SharedService } from '../common/shared.service';

@Component({
  selector: 'app-instance-page',
  templateUrl: './instance.component.html'
})
export class InstanceComponent implements OnInit {
  IsCheckedAuthentication: boolean = false;
  isUpload: any;
  ButtonText: string = "";
  InstanceTitle: string = Constants.InstanceTitle;
  InstanceInfo: string = Constants.InstanceInfo;
  InstanceLabel: string = Constants.InstanceLabel;
  InstanceErrorMessage: string = Constants.InstanceErrorMessage;
  InstanceBannerMessage: string = Constants.InstanceBannerMessage;
  InstanceInputPlaceholder: string = Constants.InstanceInputPlaceholder;
  HighQDemoText: string = Constants.HIGHQDEMOTEXT;
  HighQDemoLinkText: string = Constants.HIGHQDEMOLINKTEXT;  
  HighQDemoTextEnd:string=Constants.HIGHQDEMOTEXTEND;
  HighQDemoLink:string=Constants.HIGHQDEMOLINK;
  LoginKBNoteText: string = Constants.LoginKBNoteText;
  LoginKBNoteLinkText: string = Constants.LoginKBNoteLinkText;
  KnowledgebaseLink: string = Constants.KNOWLEDGEBASELINK;
  ErrorVisible: boolean = false;
  loading: boolean = true;

  constructor(
    private apiService: APIService,
    private sharedService: SharedService,
    private renderer: Renderer2) {
  }
  ngOnInit() {
    this.ButtonText = Constants.InstanceConnectButtonText;
    this.ErrorVisible = false;
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
  }

  ngAfterViewInit() {
    var height = this.scrollheight.nativeElement.offsetHeight;
    this.renderer.setStyle(this.fixheight.nativeElement, "padding-bottom", height+"px");
  }
  
  @ViewChild('scrollheight')
  scrollheight: ElementRef;

  @ViewChild('fixheight')
  fixheight: ElementRef;
  
  ngAfterViewChecked() {
    if (String(GlobalConstants.Tid).length > 0) {
      this.loading = false;
      this.SetControlVisibility('divLogin', 'visible');
    }
  }
  btnConnectClick() {
    this.ButtonText = Constants.InstanceLoadingButtonText;
    var inputValue = (<HTMLInputElement>document.getElementById("url")).value;
    if (!this.isValidUrl(inputValue)) {
      this.ButtonText = Constants.InstanceConnectButtonText;
      this.ErrorVisible = true;
      return;
    }
    this.getLoginUrl(btoa(inputValue));
  }

  isValidUrl(string) {
    var res = string.match(/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);
    return (res !== null)
  }

  getLoginUrl(inputValue) {
    this.apiService.getInstance(inputValue)
      .subscribe(data => {
        window.open(data['Url']); //To solve safari issue of POP-UP blocker
        this.apiService.submitTask(null);
      }, err => {
        this.ButtonText = Constants.InstanceConnectButtonText;
        this.ErrorVisible = true;
      });
  }

  public SetControlVisibility(Control, Visibility) {
    (<HTMLInputElement>document.getElementById(Control)).style.visibility = Visibility;
  }
}
